import React from 'react';
import styled from 'styled-components';
import logoImg from 'assets/img/logo.png';
import LangswitcherWithHelp from 'components/atoms/Langswitcher/LangswitcherWithHelp';

const StyledWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledLogo = styled.img`
  width: 200px;
  padding-top: 100px;
  padding-bottom: 2rem;
  @media (min-width: 700px) {
    padding-top: 130px;
  }
  @media (max-width: 412px) {
    padding-bottom: 0;
  }
`;

const StyledAuthCard = styled.div`
  width: 400px;
  height: 460px;
  padding: 0 40px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 412px) {
    width: 100vw;
    height: 100vh;
  }
`;

const AuthTemplate = ({ children }) => (
  <StyledWrapper>
    <LangswitcherWithHelp />
    <StyledLogo src={logoImg} alt="" />
    <StyledAuthCard>{children}</StyledAuthCard>
  </StyledWrapper>
);

export default AuthTemplate;
